import { styled } from "@/stitches.config";

export const DNARegistryWrapper = styled("div", {
  position: "relative",
  padding: "$md",
  maxHeight: "60vh",
  overflow: "auto",

  "& *": {
    fontSize: "$base",
  },

  "@bp_520": {
    padding: "$md $sm",
  },
});

export const InputsWrapper = styled("div", {
  display: "grid",
  gridTemplateColumns: "4fr 1fr 10fr 3fr",
  columnGap: "$sm",
  alignItems: "center",
  marginTop: "$md",

  "@bp_520": {
    gridTemplateColumns: "5fr 1fr 8fr 3fr",
    columnGap: "0.5rem",
  },
});

export const Input = styled("input", {
  display: "block",
  width: "100%",
  boxShadow: "$shadow_2",
  padding: "$sm",
  border: "none",
  "&:focus": {
    outline: "none",
  },
});

export const Separator = styled("span", {
  fontWeight: "bold",
  textAlign: "center",
});

export const ResultWrapper = styled("div", {
  marginTop: "$md",
});

export const ResultTextBox = styled("div", {
  padding: "$md",
  boxShadow: "$shadow_1",
  marginTop: "$sm",
  minHeight: "8rem",
  backgroundColor: "$mono_white",
  lineHeight: "1.6",
});

